import axios from 'axios';
import { getItem, removeItem } from '../utils/localStorageControl';
import Cookies from 'js-cookie';
import { notification } from 'antd';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

const authHeader = () => {
  const token = getItem('access_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const client = axios.create({
  baseURL: API_ENDPOINT,
  headers: {
    'Content-Type': 'application/json',
  },
});

const allClient = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

class DataService {
  static get(path = '', params = {}) {
    return client({
      method: 'GET',
      url: path,
      params,
      headers: { ...authHeader() },
    });
  }

  static getUrl(path = '') {
    return allClient({
      method: 'GET',
      url: path,
      headers: { ...authHeader() },
    });
  }

  static post(path = '', data = {}, optionalHeader = {}) {
    return client({
      method: 'POST',
      url: path,
      data,
      headers: { ...authHeader(), ...optionalHeader },
    });
  }

  static patch(path = '', data = {}) {
    return client({
      method: 'PATCH',
      url: path,
      data: JSON.stringify(data),
      headers: { ...authHeader() },
    });
  }

  static put(path = '', data = {}) {
    return client({
      method: 'PUT',
      url: path,
      data: JSON.stringify(data),
      headers: { ...authHeader() },
    });
  }

  static delete(path = '') {
    return client({
      method: 'DELETE',
      url: path,
      headers: { ...authHeader() },
    });
  }

}

/**
 * axios interceptors runs before and after a request, letting the developer modify req,req more
 * For more details on axios interceptor see https://github.com/axios/axios#interceptors
 */
client.interceptors.request.use(config => {
  // do something before executing the request
  // For example tag along the bearer access token to request header or set a cookie
  let requestConfig: any = config;
  const { headers } = config;
  requestConfig.headers = { ...headers, Authorization: `Bearer ${getItem('access_token')}` };
  return requestConfig;
});

client.interceptors.response.use(
  response => response,
  error => {
    const { response } = error;

    // Si no hay respuesta (problemas de red, por ejemplo)
    if (!response) return Promise.reject(error);

    // Manejo de errores 500
    if (response.status === 500) {
      return Promise.reject(error); // <-- aquí estaba mal
    }

    // Manejo de errores 401 o 403
    if (response.status === 401 || response.status === 403) {
      const isAuthError =
        response.status === 401 &&
        response.config?.url?.includes('/auth') && // solo si viene de login/token
        response.data?.message === 'Please authenticate';

      if (isAuthError) {
        Cookies.remove('logedIn');
        removeItem('access_token');
        removeItem('refresh_token');
        removeItem('user');
        (window.location as Location).replace(window.location.origin);
        return Promise.reject(error); // importante!
      }
    }

    // Para cualquier otro error
    return Promise.reject(error); // <-- importante
  }
);

export { DataService };
